export function moneyFormat(x, currency) {
  let formated = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return (
    <span>
      <span dir="ltr">{formated}</span>
      {currency !== false && <span>{" تومان"}</span>}
    </span>
  );
}

export default moneyFormat;
